<template>
	<div class="content">
		<van-nav-bar
		  title="个人中心"
		  @click-left="onClickLeft"
		  left-arrow
		  
		/>
		<van-row class="text_listx">
			 
			  <van-col span="24" class='text_listhead'>
					  <van-col span="24" class='' style="text-align: center;">
						    <van-col span="24">
								<span  id='img_el'>
								<img  style="" :src="headPhoto"></img>
								</span>
							 <!-- <img class='wx_img' src="../../../../static/mj.jpg">-->
					     </van-col>
					 
					  </van-col>
					  
					   <van-col span="24" class='' style="text-align: center;">
						 
						  <van-col span="24" class='text_a_' >{{name}}</van-col>
						
						  <van-col span="24" class='text_a'>{{dizhi}}</van-col>
					   </van-col>
			 </van-col> 
			  <van-col span="24" class='text_listbtn'>
				   
				 <van-col class="list" @click="order()"  span="24"  >
					 
					<van-col span="2" style=" height: 30px; margin-top:23px; padding-left: 10px;" >
						<span style="display: inline-block; width: 25px; 
							text-align: center;
							height: 25px;
							border-radius: 50%; background-color:#FF4A53;">
							
							<van-icon name="bars" color="#ffffff" style="margin-top:5px;" />
						</span>
					</van-col>	
					
					<van-col span="16" style="color:#333333; height: 30px;margin-top:25px; padding-left:10px; font-weight:800; ">
					  订单详情 
					</van-col>	
				<van-col span="6" style="padding-top:0px; height: 36px; margin-top:22px; text-align: right;padding-right: 10px;" >
				 <van-button type="primary" round size="mini" style=" background-color:#FFFFFF; color: #FF4A53; border: 1px solid #FF4A53;">查看更多</van-button>
				</van-col>	
			 </van-col>
					 
			   </van-col> 
			 <!-- <van-cell title="进出明细" is-link />-->
		</van-row>
		<van-tabbar v-model="active" active-color="#FF4A53">
			    <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
				<van-tabbar-item icon="setting-o"  @click="user()">个人中心</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
export default {
  data () {
    return {
    	  headPhoto:'../../../../../static/11111.jpg',
          foo: 'bar',
	      active: 1,
		  tel: '',
	      text: '',
	      digit: '',
	      number: '',
	      dizhi:"",
	      name:'',
	    }
    },
      mounted(){
    	this.userlist();
    
    },
	methods: {
		userlist(){
			let storage=window.sessionStorage;
    		let openid = storage.getItem("openid")
			this.$axios({
					url: "/api/wechat/findWXUser",
					method: "get",
					params: {
						openid: openid,
					}
				})
			.then(res => {
				var dataa= res.data
				 var data = res.data[0];
                 if(dataa==""){
					 this.dizhi="暂无"
					 this.name="暂无"
				 }else{
					 this.headPhoto= data.headimgurl;
					this.dizhi= data.country +  data.province +  data.city ;
					 this.name = data.nickname;
					 	
					
				 }
				 
				 console.log(data)
			 
			 })
			.catch(err => {
				console.log(err);
			});
		},
	     home(){
	        this.$router.push({ path: "/wx_ticketIndex"});
	    },
	    user(){
	    	 this.$router.push({ path: "/wx_ticketUser" });
	    },
		order(){
			this.$router.push({ path: "/wx_ticketOrderlist" });
		},
		 onClickLeft(){
	    	this.$router.go(-1);//返回上一层
			//this.$router.push({ path: "/wx_ticketUser",query: { total: total , numlist: numlist }  });
		},
	  /*  onClickLeft() {
      Toast('返回');
	    }*/
	   
	   
	  }
  
}
</script>

<style scoped>

	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	#img_el {
		display: inline-block;
		width:80px; 
		height:80px;
		border-radius:50%;
		
	
	}
	#img_el img{
		width: 80px;
		 height: 80px;
		 border-radius:50%;
	
	}
	
	.wx_img{
		width: 58px;
		height: 58px;
		
		
	}
	.text_a_{
		height: 40px;
		line-height: 40px;
		font-size: 20px;
	
		color: #FFFFFF ;
	
		
	}
	.text_a{
		height: 40px;
		line-height: 40px;
		
		color: #FFFFFF ;
	}
	
	.text_listx{
	
		font-size: 14px;
		text-align: left;
		height: 370px;
		 background-image: linear-gradient(#FF4A53, #FFffff);
	}
	.text_listhead{
		margin-top: 10px;
		width: 90%;
		margin-left: 5%;
		padding-top: 20px;
	
		padding-bottom: 20px;
	
	}
	.text_listbtn{
		margin-top: 10px;
		width: 90%;
		height: 70px;
		margin-left: 5%;
		border-radius: 10px;
		background-color: #FFFFFF;
		
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketUser.vue